// extracted by mini-css-extract-plugin
export default {"fixed-footer":"IVL1q","fixed-share-button":"UAagR"};